import { provideTransloco, provideTranslocoTranspiler, TranslocoModule } from '@jsverse/transloco';
import { NgModule } from '@angular/core';
import { TranslocoHttpLoader } from './transloco-loader';
import { BrandTranspiler } from './brand.transpiler';
import { environment } from '../../environments/environment';
import { provideTranslocoLocale, TranslocoLocaleModule } from '@jsverse/transloco-locale';
import { KAZAKHSTAN_INTL_LOCALE } from '@shared/utils/intl-locale.util';
import { BUILD_DEFAULTS } from '../../environments/environment-files/build-defaults.const';

@NgModule({
  exports: [TranslocoModule, TranslocoLocaleModule],
  providers: [
    provideTransloco({
      config: {
        availableLangs: ['ru', 'en', 'tr', 'kk', 'zh'],
        defaultLang: BUILD_DEFAULTS[environment.build].language,
        fallbackLang: BUILD_DEFAULTS[environment.build].language,
        reRenderOnLangChange: true,
        prodMode: environment.production,
      },
      loader: TranslocoHttpLoader,
    }),
    provideTranslocoTranspiler(BrandTranspiler),

    provideTranslocoLocale({
      langToLocaleMapping: {
        en: 'en-US',
        ru: 'ru-RU',
        kk: KAZAKHSTAN_INTL_LOCALE,
        tr: 'tr-TR',
        zh: 'zh-Hans-CN',
      },
      defaultLocale: 'en-US',
    }),
  ],
})
export class TranslocoRootModule {}
